import React from "react";

export default function CommonLoader({ text = "Loading..." }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.spinner}></div>
      <span style={styles.text}>{text}</span>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(255, 255, 255, 0.8)",
    zIndex: 1200,
    flexDirection: "column",
  },
  spinner: {
    border: "6px solid #f3f3f3",   // light gray
    borderTop: "6px solid #03bbae !important", // blue (तू बदलू शकतोस)
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    animation: "spin 1s linear infinite",
  },
  text: {
    marginTop: 12,
    fontSize: 16,
    fontWeight: 500,
    color: "#333",
  },
};

const styleSheet = document.styleSheets[0];
const keyframes =
  `@keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
   }`;
styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
